<div class="textarea-component">
  <textarea #textarea (ngModelChange)="onChange($event)" [(ngModel)]="value" [attr.maxLength]="maxlength || null"></textarea>
  <ParagraphAtom class="textarea-charactersCount" *ngIf="maxlength !== undefined" color="medium-grey" weight="medium" size="small" text="{{remainingCharacters}} Caractères restants"></ParagraphAtom>
</div>
